/**
 * @generated SignedSource<<74e52527ba1045dd21118e14662f445c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AppLeftSidebarMainQuery$variables = {
  lastUsedTool: number;
};
export type AppLeftSidebarMainQuery$data = {
  readonly currentIAMUser: {
    readonly isIAMUser: boolean;
    readonly permissions: ReadonlyArray<string>;
  };
  readonly treeMenu: string;
};
export type AppLeftSidebarMainQuery = {
  response: AppLeftSidebarMainQuery$data;
  variables: AppLeftSidebarMainQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "lastUsedTool"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "lastUsedTool",
        "variableName": "lastUsedTool"
      }
    ],
    "kind": "ScalarField",
    "name": "treeMenu",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "CurrentIAMUser",
    "kind": "LinkedField",
    "name": "currentIAMUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isIAMUser",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "permissions",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AppLeftSidebarMainQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AppLeftSidebarMainQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "de722b3034d4ea949b23ff92282fa9dd",
    "id": null,
    "metadata": {},
    "name": "AppLeftSidebarMainQuery",
    "operationKind": "query",
    "text": "query AppLeftSidebarMainQuery(\n  $lastUsedTool: Int!\n) {\n  treeMenu(lastUsedTool: $lastUsedTool)\n  currentIAMUser {\n    isIAMUser\n    permissions\n  }\n}\n"
  }
};
})();

(node as any).hash = "df0b635000ab12290ae5b7fab66b6f4f";

export default node;
